export default "__VITE_ASSET__10e2e014__"